import { useTranslation } from 'react-i18next';

import { GameLoginTokenSection } from '@/pages/auth/game-login-token-section';

/**
 * The in-game login token screen (legacy "Login token" page, gated by
 * <RequireAuth>): the rotating `!login` code, a countdown to its refresh and
 * the authenticator QR so players don't need the browser every time.
 */
export default function LoginTokenPage() {
  const { t } = useTranslation('common');

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-5">
      <h1 className="font-display text-strong mb-6 text-2xl">{t('nav.loginToken')}</h1>
      <GameLoginTokenSection />
    </div>
  );
}
